export default {
    list: {
        title: 'Team',
        subtitle: 'Manage team members',
        invite: 'Invite Member',
        loading: 'Loading team...',
        addMember: 'Add Member',
        allRoles: 'All roles',
        allStatuses: 'All statuses',
        searchPlaceholder: 'Search by name or email...',
        rolePlaceholder: 'Filter by role',
        statusPlaceholder: 'Filter by status',
        description: 'List of your team members',
        headers: {
            name: 'Name',
            email: 'Email',
            role: 'Role',
            status: 'Status',
            lastLogin: 'Last Login',
            inviteDate: 'Invite Date',
            actions: 'Actions',
        },
        noMembers: {
            title: 'No team members found',
            message: 'Try modifying the search filters',
            emptyMessage: 'Start by adding your first team member',
            addFirst: 'Add First Member',
        },
        modal: {
            addTitle: 'Invite Member',
            editTitle: 'Edit Member',
            removeTitle: 'Remove Member',
            fields: {
                name: 'Name',
                namePlaceholder: 'Enter name',
                email: 'Email',
                emailPlaceholder: 'name@company.com',
                firstName: 'First Name',
                firstNamePlaceholder: 'Enter first name',
                lastName: 'Last Name',
                lastNamePlaceholder: 'Enter last name',
                role: 'Role',
                rolePlaceholder: 'Select role',
                status: 'Status',
                statusPlaceholder: 'Select status',
                isActive: 'Active',
            },
            roles: {
                operator: 'Operator',
                companyAdmin: 'Admin',
            },
            cancel: 'Cancel',
            save: 'Save',
            create: 'Create',
            invite: 'Send Invitation',
            confirmRemove: 'Remove Member',
            removeConfirmation: 'Are you sure you want to remove {{name}} ({{email}}) from your team? This action cannot be undone.',
            sendNotificationEmail: 'Send notification email to the user',
            success: {
                memberInvited: 'Invitation sent successfully',
                memberUpdated: 'Member updated successfully',
                memberRemoved: 'Member removed successfully',
            },
            error: {
                emailRequired: 'Email is required',
                invitingMember: 'Error inviting member',
                updatingMember: 'Error updating member',
                removingMember: 'Error removing member',
            },
        },
        statusLabels: {
            active: 'Active',
            inactive: 'Inactive',
        },
        actions: {
            edit: 'Edit',
            remove: 'Remove',
        },
        never: 'Never',
        confirmDelete: 'Are you sure you want to delete this team member?',
    },
};
